import React, { useState, FC } from 'react'
import { FormProjectField } from '../../api/shared'
import { TextBox } from '../../../../../legacy-design-system/form-text-box'

export interface NumberFieldProps {
  field: FormProjectField
  updateValue: (value: any) => void
}

export const NumberField: FC<NumberFieldProps> = ({ field, updateValue }) => {
  const [value, setValue] = useState(field?.value)
  const onInputChange = (e) => {
    setValue(e.target.value)
    updateValue(e.target.value)
  }

  return <TextBox type="number" value={value} onChange={onInputChange} />
}
